module.exports = __webpack_public_path__ + "img/presentation_assistance_image.79c068de.jpg";